import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEOHead from '@/components/base/SEOHead';

const milestones = [
  { year: '2018', title: '平台创立', desc: '羞羞漫画正式上线，致力于打造正版漫画阅读平台' },
  { year: '2019', title: '快速成长', desc: '用户突破100万，签约作者超过500位，漫画库存突破1万部' },
  { year: '2020', title: '行业领先', desc: '用户突破1000万，推出多端同步阅读功能，支持iOS/Android/Web全平台' },
  { year: '2021', title: '内容升级', desc: '获得多项正版授权，独家引进海外优质漫画资源' },
  { year: '2022', title: '生态建设', desc: '启动创作者扶持计划，投入千万级资金支持原创漫画创作' },
  { year: '2023', title: '技术革新', desc: 'AI智能推荐系统上线，个性化阅读体验全面升级' },
  { year: '2024', title: '全球化布局', desc: '开始海外市场拓展，国产漫画出海至30+国家和地区' },
  { year: '2025', title: '行业标杆', desc: '用户突破4000万，成为国内领先的正版漫画阅读平台' },
  { year: '2026', title: '全新起航', desc: '用户突破5000万，平台内容数量超过10万部，开启全新篇章' },
];

const reviews = [
  {
    name: '漫画爱好者小王',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20portrait%20avatar%2C%20young%20man%2C%20warm%20expression%2C%20simple%20clean%20background%2C%20soft%20lighting%2C%20manga%20style%20illustration%2C%20warm%20tones&width=120&height=120&seq=avatar-01&orientation=squarish',
    rating: 5,
    text: '羞羞漫画真的是我用过最好的漫画阅读平台！画质清晰，更新速度超快，而且界面简洁没有广告干扰，阅读体验非常棒。推荐给了很多朋友，大家都说好！',
    date: '2026-08-10',
  },
  {
    name: '资深漫迷小李',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20portrait%20avatar%2C%20young%20woman%2C%20happy%20smile%2C%20simple%20clean%20background%2C%20soft%20lighting%2C%20manga%20style%20illustration%2C%20warm%20tones&width=120&height=120&seq=avatar-02&orientation=squarish',
    rating: 5,
    text: '从2019年就开始用羞羞漫画了，看着平台一步步成长到现在。漫画资源越来越丰富，翻译质量也很高。特别是多端同步功能，手机平板电脑无缝切换，太方便了！',
    date: '2026-08-08',
  },
  {
    name: '漫画创作者阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20portrait%20avatar%2C%20creative%20artist%20character%2C%20friendly%20expression%2C%20simple%20clean%20background%2C%20soft%20lighting%2C%20manga%20style%20illustration%2C%20warm%20tones&width=120&height=120&seq=avatar-03&orientation=squarish',
    rating: 5,
    text: '作为一名漫画创作者，羞羞漫画给了我很好的创作和发布平台。创作者后台功能完善，收益透明，编辑团队也很专业。在这里发布漫画，读者反馈特别积极！',
    date: '2026-08-05',
  },
  {
    name: '大学生小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20portrait%20avatar%2C%20college%20student%2C%20reading%20expression%2C%20simple%20clean%20background%2C%20soft%20lighting%2C%20manga%20style%20illustration%2C%20warm%20tones&width=120&height=120&seq=avatar-04&orientation=squarish',
    rating: 4,
    text: '每天睡前必看一会儿羞羞漫画，已经成了生活习惯。分类很全，推荐算法也很准，总能找到我喜欢的作品。希望平台能增加更多原创国漫！',
    date: '2026-07-30',
  },
];

const faqs = [
  {
    q: '羞羞漫画支持哪些阅读设备？',
    a: '羞羞漫画支持iOS、Android移动端、平板电脑以及PC网页端阅读。您的阅读进度和书架收藏会自动在多端同步，随时随地畅享阅读。',
  },
  {
    q: '如何注册羞羞漫画账号？',
    a: '您可以通过手机号、邮箱或第三方社交账号快速注册。注册即享免费章节阅读权益，新用户还可领取专属福利。',
  },
  {
    q: '羞羞漫画上的作品都是正版吗？',
    a: '是的，羞羞漫画平台上的所有漫画作品均获得正版授权。我们与国内外众多版权方和创作者建立了长期合作关系，确保每一部作品都是合法授权内容。',
  },
  {
    q: '漫画更新频率是怎样的？',
    a: '平台上每天有300+部漫画作品更新。热门连载漫画通常保持日更或周更的频率，具体更新计划可以在每部作品的详情页查看。',
  },
  {
    q: '如何成为羞羞漫画的签约作者？',
    a: '欢迎有才华的漫画创作者加入！您可以通过"关于我们"页面底部的联系方式发送作品集和创作计划，我们的编辑团队会在7个工作日内回复。',
  },
];

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = formData.get('website_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      setFormStatus('success');
      return;
    }

    setFormStatus('sending');
    setFormError('');

    try {
      const submitAddr = 'https://readdy.ai/api/form/d9th255ca23r0tr1aj10';
      const urlEncoded = new URLSearchParams();
      formData.forEach((value, key) => {
        if (key !== 'website_alt') {
          urlEncoded.append(key, String(value));
        }
      });

      const response = await fetch(submitAddr, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: urlEncoded.toString(),
      });

      const responseText = await response.text();
      let parsed: Record<string, unknown> | null = null;
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }
      const serverMsg = (parsed && (parsed as Record<string, unknown>).meta && ((parsed as Record<string, unknown>).meta as Record<string, unknown>).message) as string
        || (parsed && (parsed as Record<string, unknown>).message) as string
        || (parsed && (parsed as Record<string, unknown>).meta && ((parsed as Record<string, unknown>).meta as Record<string, unknown>).detail) as string
        || responseText;

      if (!response.ok || (parsed && (parsed as Record<string, unknown>).code !== 'OK')) {
        throw new Error(String(serverMsg || '提交失败，请稍后重试'));
      }

      setFormStatus('success');
      form.reset();
    } catch (err: unknown) {
      setFormStatus('error');
      const msg = err instanceof Error ? err.message : '提交失败，请稍后重试';
      setFormError(msg.includes('spam') || msg.includes('form data is spam') ? '提交失败，请稍后重试' : msg);
    }
  };
  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '羞羞漫画',
    url: 'https://xiuxiumanhua.com',
    description: '专注于成人向漫画内容的正版阅读平台，海量独家漫画资源，支持多端同步阅读。',
    foundingDate: '2018',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'kefu@xiuxiumanhua.com',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
    address: {
      '@type': 'PostalAddress',
      addressCountry: 'CN',
      addressLocality: '北京',
      streetAddress: '北京市朝阳区建国路88号SOHO现代城',
    },
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.a,
      },
    })),
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://xiuxiumanhua.com/' },
      { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://xiuxiumanhua.com/about' },
    ],
  };

  return (
    <>
      <ScrollToTop />
      <SEOHead
        title="关于羞羞漫画 - 正版漫画阅读平台"
        description="羞羞漫画成立于2018年，是国内领先的正版漫画阅读平台。了解我们的品牌故事、发展历程、用户口碑，以及联系我们获取更多信息。"
        keywords="羞羞漫画,关于羞羞漫画,漫画平台,正版漫画,联系我们"
        canonicalUrl="/about"
        schemaData={{ ...orgSchema, ...faqSchema, ...breadcrumbSchema }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <div className="pt-16">
          {/* Hero */}
          <section className="relative py-16 md:py-24 overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Warm%20cozy%20reading%20space%20with%20bookshelves%20full%20of%20manga%2C%20soft%20ambient%20lighting%2C%20comfortable%20reading%20nook%2C%20literary%20atmosphere%2C%20warm%20golden%20and%20cream%20tones%2C%20clean%20aesthetic%20composition%2C%20peaceful%20library%20vibe&width=1800&height=600&seq=about-hero&orientation=landscape"
              alt="羞羞漫画品牌"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50" />
            <div className="relative max-w-[1440px] mx-auto px-4 md:px-6 text-center">
              <h1 className="text-3xl md:text-4xl font-bold text-white mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                关于羞羞漫画
              </h1>
              <p className="text-white/70 text-sm md:text-base max-w-xl mx-auto">
                正版授权，品质阅读。让每一位漫迷都能享受到最优质的漫画内容。
              </p>
            </div>
          </section>

          {/* Brand Introduction */}
          <section className="py-10 md:py-14">
            <div className="max-w-[1440px] mx-auto px-4 md:px-6">
              <div className="max-w-3xl mx-auto">
                <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
                  品牌介绍
                </h2>
                <div className="space-y-4 text-sm text-foreground-600 leading-relaxed">
                  <p>
                    羞羞漫画成立于2018年，是国内领先的<strong>正版漫画阅读平台</strong>。我们致力于为广大漫迷提供海量优质的漫画内容，
                    涵盖玄幻、恋爱、都市、科幻、悬疑、古装、耽美等多种热门题材，满足不同读者的多样化阅读需求。
                  </p>
                  <p>
                    作为国内最早一批专注于<strong>成人向漫画</strong>内容的平台，羞羞漫画始终坚持"正版授权、品质阅读"的核心理念。
                    我们与国内外众多知名漫画创作者和版权方建立了长期稳定的合作关系，确保平台上的每一部作品都获得合法授权。
                  </p>
                  <p>
                    截至目前，平台注册用户已突破<strong>5000万</strong>，漫画作品库存超过<strong>10万部</strong>，每日更新作品<strong>300+部</strong>。
                    我们支持iOS、Android、平板电脑及PC网页端的多端同步阅读，让用户随时随地畅享漫画的乐趣。
                  </p>
                  <p>
                    未来，羞羞漫画将继续深耕漫画领域，加大原创内容扶持力度，推动国产漫画的创作与发展，为全球华语读者提供更优质的漫画阅读体验。
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Milestones */}
          <section className="py-10 md:py-14 bg-background-100">
            <div className="max-w-[1440px] mx-auto px-4 md:px-6">
              <div className="max-w-3xl mx-auto">
                <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-8" style={{ fontFamily: 'var(--font-heading)' }}>
                  发展历程
                </h2>
                <div className="relative">
                  <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-background-300" />
                  <div className="space-y-8">
                    {milestones.map((m, idx) => (
                      <div key={m.year} className="relative pl-12 md:pl-16">
                        <div className="absolute left-2.5 md:left-4 top-1 w-3.5 h-3.5 rounded-full bg-primary-500 border-2 border-background-50" />
                        <span className="text-xs font-bold text-primary-500 bg-primary-50 px-2 py-0.5 rounded-full inline-block mb-1">
                          {m.year}
                        </span>
                        <h3 className="text-base font-semibold text-foreground-950 mb-1">{m.title}</h3>
                        <p className="text-sm text-foreground-500">{m.desc}</p>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Reviews */}
          <section className="py-10 md:py-14">
            <div className="max-w-[1440px] mx-auto px-4 md:px-6">
              <div className="max-w-3xl mx-auto">
                <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
                  用户口碑
                </h2>
                <p className="text-sm text-foreground-500 mb-8">听听我们的用户怎么说</p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  {reviews.map((review) => (
                    <div key={review.name} className="bg-background-100 rounded-xl p-5">
                      <div className="flex items-center gap-3 mb-3">
                        <img
                          src={review.avatar}
                          alt={review.name}
                          className="w-10 h-10 rounded-full object-cover"
                        />
                        <div>
                          <p className="text-sm font-semibold text-foreground-950">{review.name}</p>
                          <div className="flex items-center gap-0.5">
                            {Array.from({ length: 5 }, (_, i) => (
                              <i
                                key={i}
                                className={`text-xs ${i < review.rating ? 'ri-star-fill text-accent-500' : 'ri-star-fill text-background-300'}`}
                              ></i>
                            ))}
                          </div>
                        </div>
                        <span className="ml-auto text-[11px] text-foreground-500">{review.date}</span>
                      </div>
                      <p className="text-sm text-foreground-600 leading-relaxed">{review.text}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>

          {/* FAQ */}
          <section className="py-10 md:py-14 bg-background-100">
            <div className="max-w-[1440px] mx-auto px-4 md:px-6">
              <div className="max-w-3xl mx-auto">
                <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-8" style={{ fontFamily: 'var(--font-heading)' }}>
                  常见问题
                </h2>
                <div className="space-y-3">
                  {faqs.map((faq, idx) => (
                    <details key={idx} className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden">
                      <summary className="flex items-center justify-between px-5 py-4 cursor-pointer list-none">
                        <span className="text-sm font-medium text-foreground-950 pr-4">{faq.q}</span>
                        <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform text-lg flex-shrink-0"></i>
                      </summary>
                      <div className="px-5 pb-4">
                        <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                      </div>
                    </details>
                  ))}
                </div>
              </div>
            </div>
          </section>

          {/* Contact */}
          <section id="contact" className="py-10 md:py-14">
            <div className="max-w-[1440px] mx-auto px-4 md:px-6">
              <div className="max-w-3xl mx-auto">
                <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
                  联系我们
                </h2>
                <p className="text-sm text-foreground-500 mb-8">如有任何问题或合作意向，欢迎通过以下方式联系我们</p>

                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
                  <div className="bg-background-100 rounded-xl p-5 text-center">
                    <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                      <i className="ri-mail-line text-xl text-primary-500"></i>
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-950 mb-1">客服邮箱</h3>
                    <p className="text-sm text-foreground-500">kefu@xiuxiumanhua.com</p>
                  </div>
                  <div className="bg-background-100 rounded-xl p-5 text-center">
                    <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center">
                      <i className="ri-phone-line text-xl text-accent-500"></i>
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-950 mb-1">商务合作</h3>
                    <p className="text-sm text-foreground-500">bd@xiuxiumanhua.com</p>
                  </div>
                  <div className="bg-background-100 rounded-xl p-5 text-center">
                    <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-secondary-100 flex items-center justify-center">
                      <i className="ri-map-pin-line text-xl text-secondary-500"></i>
                    </div>
                    <h3 className="text-sm font-semibold text-foreground-950 mb-1">公司地址</h3>
                    <p className="text-sm text-foreground-500">北京市朝阳区建国路88号</p>
                  </div>
                </div>

                <div className="bg-background-100 rounded-xl p-6">
                  <h3 className="text-base font-semibold text-foreground-950 mb-4">给我们留言</h3>
                  <form className="space-y-4" data-readdy-form="" onSubmit={handleSubmit}>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div>
                        <label htmlFor="about-name" className="block text-xs text-foreground-600 mb-1.5">姓名</label>
                        <input
                          type="text"
                          id="about-name"
                          name="name"
                          required
                          className="w-full px-3.5 py-2.5 rounded-lg bg-background-50 border border-background-200/70 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                          placeholder="请输入您的姓名"
                        />
                      </div>
                      <div>
                        <label htmlFor="about-email" className="block text-xs text-foreground-600 mb-1.5">邮箱</label>
                        <input
                          type="email"
                          id="about-email"
                          name="email"
                          required
                          className="w-full px-3.5 py-2.5 rounded-lg bg-background-50 border border-background-200/70 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                          placeholder="请输入您的邮箱"
                        />
                      </div>
                    </div>
                    <div>
                      <label htmlFor="about-subject" className="block text-xs text-foreground-600 mb-1.5">主题</label>
                      <input
                        type="text"
                        id="about-subject"
                        name="subject"
                        required
                        className="w-full px-3.5 py-2.5 rounded-lg bg-background-50 border border-background-200/70 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors"
                        placeholder="请输入主题"
                      />
                    </div>
                    <div>
                      <label htmlFor="about-message" className="block text-xs text-foreground-600 mb-1.5">留言内容</label>
                      <textarea
                        id="about-message"
                        name="message"
                        rows={4}
                        maxLength={500}
                        required
                        className="w-full px-3.5 py-2.5 rounded-lg bg-background-50 border border-background-200/70 text-sm text-foreground-950 placeholder:text-foreground-400 focus:outline-none focus:border-primary-300 transition-colors resize-none"
                        placeholder="请输入您的留言（不超过500字）"
                      ></textarea>
                      <p className="text-[11px] text-foreground-400 mt-1">最多500个字符</p>
                    </div>
                    <div className="form-website-alt-wrap">
                      <label htmlFor="about-website-alt">备用网站</label>
                      <input
                        type="text"
                        id="about-website-alt"
                        name="website_alt"
                        tabIndex={-1}
                        autoComplete="off"
                        aria-hidden="true"
                        readOnly
                      />
                    </div>

                    {formStatus === 'success' && (
                      <div className="flex items-center gap-2 px-4 py-3 rounded-lg bg-green-50 border border-green-200 text-sm text-green-700">
                        <i className="ri-checkbox-circle-line text-lg"></i>
                        留言已成功发送，我们会尽快回复您！
                      </div>
                    )}
                    {formStatus === 'error' && (
                      <div className="flex items-center gap-2 px-4 py-3 rounded-lg bg-red-50 border border-red-200 text-sm text-red-700">
                        <i className="ri-error-warning-line text-lg"></i>
                        {formError}
                      </div>
                    )}

                    <button
                      type="submit"
                      disabled={formStatus === 'sending'}
                      className="px-6 py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 disabled:opacity-60 disabled:cursor-not-allowed transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {formStatus === 'sending' ? (
                        <>
                          <i className="ri-loader-4-line animate-spin mr-1.5"></i>发送中...
                        </>
                      ) : (
                        '发送留言'
                      )}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </section>
        </div>

        <Footer />
      </div>
    </>
  );
}